import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import api from '../../../utils/api';

const NUM_LEADS_TO_FETCH = 100;
const TWO_WEEKS_AGO = 14;

function LeadContactInfo(conversation) {
  return { name: conversation.inquiry.name, conversationId: conversation.conversationId, isIncluded: true };
}

export const useGhostedLeads = (listingAlias, isMultifamily) => {
  const dispatch = useDispatch();
  const [ghostedLeads, setGhostedLeads] = useState([]);

  useEffect(() => {
    if (isMultifamily) {
      return;
    }
    const paginatedLeadRequests = [];
    // fetch 10 leads at a time to prevent an expensive query.
    for (let start = 0; start < NUM_LEADS_TO_FETCH; start += 10) {
      paginatedLeadRequests.push(
        dispatch(
          api.users.leads.allLeads({
            readRepliedStatus: 'notRepliedTo',
            daysBack: TWO_WEEKS_AGO,
            listingAlias,
            limit: 10,
            start,
          }),
        ),
      );
    }
    Promise.allSettled(paginatedLeadRequests).then((results) => {
      const conversations = results.flatMap((result) => {
        return result?.value?.response?.conversations ?? [];
      });
      setGhostedLeads(conversations.map(LeadContactInfo));
    });
  }, []);

  const toggleIncludeLead = useCallback(
    (i) => {
      const newGhostedLeads = [...ghostedLeads];
      newGhostedLeads[i].isIncluded = !ghostedLeads[i].isIncluded;
      setGhostedLeads(newGhostedLeads);
    },
    [ghostedLeads, setGhostedLeads],
  );

  return { ghostedLeads, toggleIncludeLead };
};

export const useNotAvailableMessage = (street, name) => {
  const [notAvailableMessage, setNotAvailableMessage] = useState('');

  useEffect(() => {
    setNotAvailableMessage(`Hello,

The ${street} property you inquired about is no longer available. Thank you for your interest.

Best regards,

${name}`);
  }, [street, name]);

  return { notAvailableMessage, setNotAvailableMessage };
};
